import { render, staticRenderFns } from "./FulfillmentService.vue?vue&type=template&id=3424cce2&scoped=true&"
import script from "./FulfillmentService.vue?vue&type=script&lang=js&"
export * from "./FulfillmentService.vue?vue&type=script&lang=js&"
import style0 from "./FulfillmentService.vue?vue&type=style&index=0&id=3424cce2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3424cce2",
  null
  
)

export default component.exports